import { Link } from 'react-router-dom';
import { MainLayout } from '@templates/index';
import { LEGAL_CONFIG } from '@/config/legal';

const AboutPage = () => {
  return (
    <MainLayout>
      <div className="max-w-4xl mx-auto py-12 px-4">

        {/* Hero */}
        <div className="text-center mb-14">
          <h1 className="text-4xl font-bold text-gray-900 mb-4">Hakkımızda</h1>
          <p className="text-lg text-gray-500 max-w-2xl mx-auto">
            Adana'nın eşsiz lezzetlerini kapınıza taşıyan teknoloji platformu
          </p>
        </div>

        {/* Mission */}
        <section className="mb-14">
          <div className="bg-primary/5 border border-primary/20 rounded-2xl p-8">
            <h2 className="text-2xl font-bold text-gray-900 mb-4">Misyonumuz</h2>
            <p className="text-gray-700 leading-relaxed text-lg">
              <strong>Lezzet Yolda</strong>, Adana ve çevresindeki en seçkin restoranları tüketicilerle buluşturan
              hyper-lokal bir yemek sipariş platformudur. Misyonumuz; yerel restoranların dijital
              dönüşümünü hızlandırmak, tüketicilere güvenli ve hızlı bir sipariş deneyimi sunmak
              ve kurye partnerlerimize sürdürülebilir bir gelir kaynağı oluşturmaktır.
            </p>
          </div>
        </section>

        {/* Story */}
        <section className="mb-14">
          <h2 className="text-2xl font-bold text-gray-900 mb-6">Hikayemiz</h2>
          <div className="space-y-4 text-gray-700 leading-relaxed">
            <p>
              Lezzet Yolda, 2026 yılında Adana'nın köklü mutfak kültürüne teknolojinin gücünü
              katmak amacıyla kurulmuştur. Şehrin her köşesindeki esnaf restoranından tutun büyük
              zincir işletmelere kadar geniş bir yelpazede hizmet sunmayı hedefleyen platformumuz;
              müşteri memnuniyetini, şeffaflığı ve hızı temel değer olarak benimsemektedir.
            </p>
            <p>
              <strong>{LEGAL_CONFIG.companyName}</strong> çatısı altında faaliyet gösteren
              platformumuz, T.C. mevzuatına tam uyumlu şekilde, PCI-DSS sertifikalı ödeme
              altyapısı ve KVKK kapsamında kişisel verilerin korunmasına azami özen göstererek
              hizmetini sürdürmektedir.
            </p>
          </div>
        </section>

        {/* Values */}
        <section className="mb-14">
          <h2 className="text-2xl font-bold text-gray-900 mb-8">Değerlerimiz</h2>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
            {[
              {
                icon: '🚀',
                title: 'Hız',
                desc: 'Ortalama teslimat süresini minimuma indirmek için sürekli lojistik optimizasyonu yapıyoruz.',
              },
              {
                icon: '🔒',
                title: 'Güven',
                desc: 'Iyzico altyapısıyla PCI-DSS uyumlu güvenli ödeme ve KVKK kapsamında veri gizliliği sağlıyoruz.',
              },
              {
                icon: '🤝',
                title: 'Ortaklık',
                desc: 'Restoran partnerlerimizin ve kuryelerin büyümesini kendi büyümemiz olarak görüyoruz.',
              },
            ].map((v) => (
              <div key={v.title} className="bg-white border border-gray-100 rounded-2xl p-6 shadow-sm hover:shadow-md transition-shadow">
                <div className="text-4xl mb-4">{v.icon}</div>
                <h3 className="font-bold text-gray-900 text-lg mb-2">{v.title}</h3>
                <p className="text-gray-600 text-sm leading-relaxed">{v.desc}</p>
              </div>
            ))}
          </div>
        </section>

        {/* Company Info */}
        <section className="mb-14">
          <h2 className="text-2xl font-bold text-gray-900 mb-6">Şirket Bilgileri</h2>
          <div className="bg-white border border-gray-200 rounded-2xl overflow-hidden shadow-sm">
            <table className="w-full text-sm">
              <tbody className="divide-y divide-gray-100">
                {[
                  { label: 'Şirket Unvanı', value: LEGAL_CONFIG.companyName },
                  { label: 'MERSİS No', value: LEGAL_CONFIG.mersisNo },
                  { label: 'Vergi Kimlik No', value: LEGAL_CONFIG.taxNumber },
                  { label: 'Vergi Dairesi', value: LEGAL_CONFIG.taxOffice },
                  { label: 'Ticaret Sicil No', value: LEGAL_CONFIG.tradeRegistry },
                  { label: 'Adres', value: LEGAL_CONFIG.fullAddress },
                  { label: 'Telefon', value: LEGAL_CONFIG.phone },
                  { label: 'E-posta', value: LEGAL_CONFIG.email },
                ].map((row) => (
                  <tr key={row.label} className="hover:bg-gray-50">
                    <td className="px-6 py-4 font-semibold text-gray-900 w-48 bg-gray-50">{row.label}</td>
                    <td className="px-6 py-4 text-gray-700">
                      {row.label === 'E-posta' ? (
                        <a href={`mailto:${row.value}`} className="text-primary hover:underline">
                          {row.value}
                        </a>
                      ) : row.label === 'Telefon' ? (
                        <a href={`tel:${row.value}`} className="text-primary hover:underline">
                          {row.value}
                        </a>
                      ) : (
                        row.value
                      )}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </section>

        {/* CTA */}
        <section className="text-center bg-gray-900 rounded-2xl p-10 text-white">
          <h2 className="text-2xl font-bold mb-3">Bizimle İletişime Geçin</h2>
          <p className="text-gray-300 mb-6">
            Soru, öneri veya iş birliği talepleriniz için her zaman buradayız.
          </p>
          <Link
            to="/contact"
            className="inline-block bg-primary hover:bg-primary/90 text-white font-semibold px-8 py-3 rounded-2xl transition-colors"
          >
            İletişim Sayfası
          </Link>
        </section>

        <div className="mt-12 pt-8 border-t border-gray-200 flex flex-wrap gap-4">
          <Link to="/contact" className="text-primary hover:underline font-medium">İletişim</Link>
          <Link to="/careers" className="text-primary hover:underline font-medium">Kariyer</Link>
          <Link to="/privacy" className="text-primary hover:underline font-medium">Gizlilik Politikası</Link>
          <Link to="/" className="text-primary hover:underline font-medium">← Ana Sayfaya Dön</Link>
        </div>
      </div>
    </MainLayout>
  );
};

export default AboutPage;
